import React from 'react';
import surveyImage from '../../img/usage/literature_survey.png';

function LiteratureSurvey(props) {
    return (
        <div>
            <p>
                A comparison between current applications/researches of plant disease identification and post harvest crisis management with the GreenHub LK approach is shown below.
            </p>
            <img src={surveyImage} alt="survey"/>
            <br/>
            <br/>

        </div>
    );
}

export default LiteratureSurvey;
